/**
 * Pre-compiled en messages for FieldErrors
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  duplicateValue: `This value is already in use. It must be unique.`,
  emptyValue: `This field cannot be empty.`,
  invalidFormat: `Please enter a valid format.`,
  invalidFractionalNumber: `A whole number is required.`,
  invalidFromServer: `Server validation failed. Please check your input.`,
  invalidNegativeNumber: `Negative number is not supported.`,
  invalidValue: `The provided value is invalid.`,
  missingRequiredField: `This field is required. Provide a value.`,
  resourceNotFound: `The requested resource was not found.`,
  valueAboveMaximum: `Value must be less than or equal to the maximum.`,
  valueBelowMinimum: `Value must be greater than or equal to the minimum.`,
  valueBlocked: `This value is not allowed.`,
  valueOutOfRange: `Value must be within the acceptable range.`,
  valueTooLong: `This value is too long.`,
  valueTooShort: `This value is too short.`,
};
